// extracted by mini-css-extract-plugin
module.exports = {"container":"_2yQyelWUrIbBaoU34FuBkd","icon":"_1HiBSdXZ2DLJWQjSv9gfwx"};